import { ShortTxnResponse } from 'app/modules/transactions/types/responses';
import { get } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';
import { TRANSACTION_QUERY_KEYS } from 'app/modules/transactions/queries/keys';
import { useHashedId } from 'app/shared/hooks/useHashedId';

export const useGetCheckImageTransactionById = (entityExternalId: string) => {
  const { hashedId: entityHashedId, useHashed } = useHashedId(entityExternalId);
  return useQuery({
    queryKey: TRANSACTION_QUERY_KEYS.getCheckImageTransactions(
      useHashed ? entityHashedId : entityExternalId,
    ),
    queryFn: () =>
      useHashed
        ? get<ShortTxnResponse[]>(
            `/v1/entities/cached/${entityHashedId}/check-image-transactions`,
          )
        : get<ShortTxnResponse[]>(
            `/v1/entities/${encodeURIComponent(entityExternalId)}/check-image-transactions`,
          ),
    meta: {
      errorMessage:
        'Failed to fetch check image transactions for entity. Please try again.',
    },
    enabled: entityExternalId !== '',
  });
};
